import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';

interface Discipline {
  key: string;
  title: string;
  lead: string;
  description: string;
  tags: string[];
  /** Tailwind class tokens for this discipline's colour theme. */
  dotClass: string;
  lineClass: string;
  eyebrowClass: string;
  tagClass: string;
}

@Component({
  selector: 'app-mel-framework',
  standalone: true,
  imports: [CommonModule, RouterLink, ...MATERIAL_IMPORTS],
  templateUrl: './mel-framework.html',
})
export class MelFramework {
  readonly disciplines: Discipline[] = [
    {
      key: 'M',
      title: 'Monitoring',
      lead: 'Continuous progress tracking, in real time.',
      description:
        'Monitoring in the MEL framework involves the continuous and systematic collection of data on programme activities, outputs, and outcomes — tracking progress against planned targets. It identifies implementation gaps, risks, and emerging challenges early, enabling timely corrective actions. Through regular tracking and reporting, monitoring ensures transparency, accountability, and effective use of public resources.',
      tags: ['KPI Tracking', 'Progress Reports', 'Real-Time Data', 'Compliance Alerts'],
      dotClass: 'bg-emerald-400 ring-4 ring-emerald-100',
      lineClass: 'bg-emerald-200',
      eyebrowClass: 'text-emerald-600',
      tagClass: 'border-emerald-200 text-emerald-700',
    },
    {
      key: 'E',
      title: 'Evaluation',
      lead: 'Systematic assessment of effectiveness and impact.',
      description:
        "Evaluation in the MEL framework is the systematic assessment of a programme's effectiveness, impact, and value — conducted at specific milestones or after completion. It examines how well programmes achieved their goals, identifies successes and failures, and surfaces unintended outcomes, driving adaptive management and stronger accountability to citizens and development partners.",
      tags: ['Impact Assessment', 'Mid-term Reviews', 'Outcome Analysis', 'Evaluation Repository'],
      dotClass: 'bg-[#e6b012] ring-4 ring-amber-100',
      lineClass: 'bg-amber-200',
      eyebrowClass: 'text-[#e6b012]',
      tagClass: 'border-amber-200 text-amber-700',
    },
    {
      key: 'L',
      title: 'Learning',
      lead: 'Turning evidence into institutional knowledge.',
      description:
        'Learning in MEL focuses on systematically capturing insights generated from monitoring and evaluation activities to strengthen future interventions. It involves deliberate reflection on what worked, what did not, and the underlying reasons behind those outcomes — ensuring that experience is actively used to refine programme design and improve implementation.',
      tags: ['Learning Agenda', 'Policy Briefs', 'Knowledge Management', 'Adaptive Management'],
      dotClass: 'bg-[#0e3b2e] ring-4 ring-slate-200',
      lineClass: 'bg-slate-200',
      eyebrowClass: 'text-[#0e3b2e]',
      tagClass: 'border-slate-200 text-slate-700',
    },
  ];
}
